module.exports = __webpack_public_path__ + "img/logo.8399945f.svg";